const KEY = 'company_id';

const autoCompleteUrl = (q) => `/api/autocomplete-company?q=${q}&${window.params.companiesParams}`;

class FunnelCompanies {
  constructor(options) {
    this.root = document.querySelector('[data-funnel="companies"]');
    this.closeTrigger = document.querySelector('[data-trigger="close-companies"]');
    if (!this.root || !this.closeTrigger) return;
    this.developers = this.root.querySelectorAll('[data-value]');
    this.readyCheck = this.root.querySelector('[data-ready]');
    this.resetButtons = [...this.root.querySelectorAll('[data-reset]')];
    this.searchField = this.root.querySelector('[data-search="field"]');
    this.readyIds = window.params.hasReadyCompanies;
    this.onToggle = options.onToggle;
    this.onAssign = options.onAssign;
    this.onReset = options.onReset;
    this.onClose = options.onClose || (() => {});
    this.attachEvents();
  }

  handleTriggers = () => {
    const filtersContent = document.querySelector('[data-funnel="filters"]');
    if (!filtersContent) return;

    filtersContent.classList.toggle('hidden');
    this.root.classList.toggle('hidden');
    this.onClose();
  };

  attachEvents() {
    this.closeTrigger.addEventListener('click', this.handleTriggers);

    [].forEach.call(this.developers, (developer) => {
      developer.addEventListener('click', () => {
        developer.classList.toggle('-active');
        if (this.readyCheck) {
          this.readyCheck.classList.remove('-active');
        }
        this.onToggle(KEY, Number(developer.getAttribute('data-value')));
      });
    });

    if (this.readyCheck) {
      this.readyCheck.addEventListener('click', () => {
        if (!this.readyCheck.classList.contains('-active')) {
          this.readyCheck.classList.add('-active');
          [].forEach.call(this.developers, (developer) => {
            const developerId = Number(developer.getAttribute('data-value'));
            if (this.readyIds.indexOf(developerId) !== -1) {
              developer.classList.add('-active');
            } else {
              developer.classList.remove('-active');
            }
          });
          this.onAssign(KEY, this.readyIds);
        } else {
          this.readyCheck.classList.remove('-active');
          [].forEach.call(this.developers, (developer) => {
            developer.classList.remove('-active');
          });
          this.onAssign(KEY, []);
        }
      });
    }

    [].forEach.call(this.resetButtons, (button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.reset();
        this.onClose();
        this.onReset({ [KEY]: [] });
      });
    });

    this.searchField.addEventListener('input', () => {
      const q = this.searchField.value;
      if (q) {
        const searchQuery = autoCompleteUrl(q);
        fetch(searchQuery)
          .then((res) => res.json())
          .then((companyIds) => {
            if (companyIds.length) {
              this.suggest(companyIds);
            } else {
              this.suggestAll();
            }
          })
          .catch((error) => {
            console.warn(error);
          });
      } else {
        this.suggestAll();
      }
    });
  }

  count() {
    if (!this.root) return 0;

    return this.root.querySelectorAll('[data-value].-active').length;
  }

  reset() {
    if (!this.developers) return;
    [].forEach.call(this.developers, (developer) => {
      developer.classList.remove('-active');
    });

    this.readyCheck?.classList.remove('-active')
  }

  suggest(ids) {
    [].forEach.call(this.developers, (developer) => {
      const developerId = Number(developer.getAttribute('data-value'));
      if (ids.indexOf(developerId) !== -1) {
        developer.classList.remove('hidden');
      } else {
        developer.classList.add('hidden');
      }
    });
  }

  suggestAll() {
    [].forEach.call(this.developers, (developer) => {
      developer.classList.remove('hidden');
    });
  }
}

export default FunnelCompanies;
